import { useCreateAssociatedParty } from '@/shared/hooks/api/associatedParties'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { associatedPartiesCopyKey } from './associatedPartyCopy'
import { toast } from 'sonner'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { AssociatedPartyForm } from './AssociatedPartyForm'

type AddAssociatedPartyModalProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onAdded?: (id: string) => void
}

export function AddAssociatedPartyModal({
  open,
  onOpenChange,
  onAdded,
}: AddAssociatedPartyModalProps) {
  const { t } = useTranslation(['associatedParties', 'countries'])
  const { pathname } = useLocation()
  const copy = (key: string) => t(associatedPartiesCopyKey(pathname, key))
  const { mutate: createParty, isPending } = useCreateAssociatedParty()

  const handleSubmit = (
    payload: Parameters<typeof createParty>[0]
  ) => {
    createParty(payload, {
      onSuccess: (data) => {
        toast.success(copy('addModal.success'))
        onOpenChange(false)
        onAdded?.(data.id)
      },
      onError: (error) => {
        toast.error(error.message || copy('addModal.error'))
      },
    })
  }

  const handleOpenChange = (next: boolean) => {
    onOpenChange(next)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className='flex max-h-[90vh] min-h-0 max-w-4xl! flex-col overflow-hidden'>
        <DialogHeader>
          <DialogTitle>{copy('addModal.title')}</DialogTitle>
        </DialogHeader>
        <AssociatedPartyForm
          open={open}
          inputIdPrefix='add-associated-party'
          onSubmit={handleSubmit}
          onCancel={() => handleOpenChange(false)}
          submitLabel={copy('addModal.submit')}
          cancelLabel={t('addModal.cancel')}
          isPending={isPending}
        />
      </DialogContent>
    </Dialog>
  )
}
